import { render, staticRenderFns } from "./PrivilegeTab.vue?vue&type=template&id=0451884d&"
import script from "./PrivilegeTab.vue?vue&type=script&lang=js&"
export * from "./PrivilegeTab.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports